import React, { Component } from 'react';
import { connect } from 'react-redux';

import Aux from './../../hoc/_Aux';
import ArticleDetails from './../Article/Details/ArticleDetails';
import ArticleBloc from './../../containers/Article/ArticleBloc/ArticleBloc';
import FillingBloc from './../../containers/Article/FillingBloc/FillingBloc';
import * as config from './../../conf/config';

import * as articleActions from './../Article/articleActions';
import * as thematicActions from './../Thematics/thematicsActions';

import * as staticsTool from './../../utils/url/staticUrl';

class ArticlesListRenderer extends Component {

  getFullImgUrl = (imgName, profile) => {
    let img = null;

    if (imgName !== '') {
      // check if leading character is equals to '/'
      if (imgName.substring(0, 1) !== '/') {
        imgName = '/' + imgName
      }

      // assign default profile is not defined
      if (profile === '') {
        profile = 'xlarge';
      }
      const imgPath = 'media/km/' + profile + imgName;
      img = staticsTool.getFirstAsset(imgPath);
    }
    return img;

  }

  render() {

    let listOutput = null;
    let mainArticleOutput = null;

    // dynamically routes to the right component accordingly to the Router params provided
    if (this.props.match) {
      if (this.props.match.path.match('/article/') || this.props.match.path.match('/discover/article/')) { // article details page
        //const currentArticleSlug = this.props.match.params.slug;

        if (Object.keys(this.props.articleContent).length >= 0) {

          // Thematic
          let thematicName = '';
          if (typeof this.props.articleContent.kids_thematic !== 'undefined' && this.props.availableThematics.length > 0) {
            for (const thematicIndex in this.props.availableThematics) {
              const currentThematic = this.props.availableThematics[thematicIndex];
              if (currentThematic.slug === this.props.articleContent.kids_thematic) {
                thematicName = currentThematic.name;
                break;
              }
            }
          }

          // Total Reactions
          let totalReaction = 0; // default value
          if (this.props.articleContent.hasOwnProperty('id')) {
            if (this.props.reactionsArticles.length > 0) {
              totalReaction = this.props.reactionsArticles.map(reaction => {
                  if (parseInt(reaction.articleId, 10) === parseInt(this.props.articleContent.id, 10)) {
                    return parseInt(reaction.totalReactions, 10);
                  } else {
                    return 0;
                  }
                })
                .reduce(function (acc, currentValue) {
                  return acc + currentValue
                }, 0);
            }
          }

          listOutput = (<ArticleDetails content={this.props.articleContent} 
                                                  imageHelper={this.getFullImgUrl} 
                                                  thematic={thematicName}
                                                  likes={totalReaction}
                                                />);
        }
      }
    } else if (this.props.route) { // when we are coming from the App Router through a Component 
      // ie :  
      // - <Route path="/" component={HomePage} />
      // OR
      // - <Route path="/thematic/:name" component={ThematicArticleList} />   

      if (this.props.route.path.match('/thematic/') || this.props.route.path.match('/discover/thematic/')) { // thematics listing page
        const currentThematicName = this.props.route.params.name;

        listOutput = this.props.articlesByThematic.map((articleData, index) => {

          // Get image asset
          const imgName = articleData["main_block"]["content"];
          const Img = this.getFullImgUrl(imgName, 'xlarge');

          // Compute total reaction number associated to the current article
          let totalReaction = 0;
          if (this.props.reactionsArticles.length > 0) {
            for (const reactionIndex in this.props.reactionsArticles) {
              const reactionData = this.props.reactionsArticles[reactionIndex];
              if (parseInt(reactionData.articleId, 10) === parseInt(articleData.id, 10)) {
                totalReaction = parseInt(reactionData.totalReactions, 10);
              }
            }
          }

          // Thematic
          let thematicName = '';
          if (this.props.availableThematics.length > 0) {
            for (const thematicIndex in this.props.availableThematics) {
              const currentThematic = this.props.availableThematics[thematicIndex];
              if (currentThematic.slug === currentThematicName) {
                thematicName = currentThematic.name;
                break;
              }
            }
          }

          return (
            <ArticleBloc key={index} 
                                     index={index+1} 
                                     type={parseInt(articleData.document_type, 10)} 
                                     title={articleData.title} 
                                     slug= {articleData.slug}
                                     thematic={thematicName}
                                     thematicUrl={currentThematicName} 
                                     picture={Img} 
                                     likes={totalReaction}
                                     articleId= {articleData.id}  
                                     articleClicked = {this.props.isUserSignedIn?this.props.onArticleClicked:this.props.onFakeArticleClicked}
                                     isthematicList = {true}
                                    />
          )

        });

      } else if (this.props.route.path.match('/') ) { // homepage or public homepage

        if (typeof this.props.availableEditions.current !== "undefined") {
          const currentEdition = this.props.availableEditions.current;

          if (typeof currentEdition.edition_management !== "undefined" && currentEdition.edition_management.length > 0) {
            const articlesList = currentEdition.edition_management;

            // get the first article
            if (this.props.isGridDisplay) {
              mainArticleOutput = articlesList.map((rowData, rowIndex) => {
                if (rowIndex === 0) {

                  const articleData = rowData[0];
                  let articleType = articleData.hasOwnProperty('document_type') ? parseInt(articleData.document_type, 10) : '';
                  let thematicName = '';
                  let thematicSlug = '';
                  let totalReaction = 0;
                  let Img = null

                  // Thematic
                  if (this.props.availableThematics.length > 0) {
                    for (const thematicIndex in this.props.availableThematics) {
                      const currentThematic = this.props.availableThematics[thematicIndex];
                      if (currentThematic.slug === articleData.thematic) {
                        thematicName = currentThematic.name;
                        thematicSlug = currentThematic.slug;
                        break;
                      }
                    }
                  }

                  // Image    
                  if (articleData.hasOwnProperty("main_block") && articleData["main_block"].hasOwnProperty("content")) {
                    const imgName = articleData["main_block"]["content"];
                    Img = this.getFullImgUrl(imgName, 'xxlarge');
                  }

                  // get total reaction number for each article retrieved 
                  if (articleData.hasOwnProperty('id')) {
                    if (this.props.reactionsArticles.length > 0) {
                      for (const reactionIndex in this.props.reactionsArticles) {
                        const reactionData = this.props.reactionsArticles[reactionIndex];
                        if (parseInt(reactionData.articleId, 10) === parseInt(articleData.id, 10)) {
                          totalReaction = parseInt(reactionData.totalReactions, 10);
                        }
                      }
                    }
                  }

                  return (
                    <ArticleBloc key={rowIndex} 
                                            index={rowIndex+1} 
                                            position = ''
                                            type={articleType} 
                                            title={articleData.title} 
                                            slug= {articleData.slug}
                                            articleId= {articleData.id} 
                                            thematic={thematicName}
                                            thematicUrl= {thematicSlug}  
                                            picture={Img} 
                                            likes={totalReaction} 
                                            articleClicked = {this.props.isUserSignedIn?this.props.onArticleClicked:this.props.onFakeArticleClicked}
                                            thematicClicked = {this.props.onThematicClicked}
                                            />
                  )
                } else {
                  return;
                }
              });
            }

            listOutput = articlesList.map((rowData, rowIndex) => {
              let articleRowData = [];

              if (rowIndex === 0 && this.props.isGridDisplay) {
                articleRowData = []; // skip the first one article
              } else {

                if (rowData.length === 1) {

                  articleRowData.push(rowData[0]);

                } else {
                  articleRowData.push(rowData[0]);
                  articleRowData.push(rowData[1]);

                }
              }

              return articleRowData.map((articleData, blocIndex) => {

                let isBlocBouchon = false;
                let articleType = articleData.hasOwnProperty('document_type') ? parseInt(articleData.document_type, 10) : '';
                let blocType = '';

                // get total reaction number for each article retrieved 
                let totalReaction = 0;
                if (articleData.hasOwnProperty('id')) {
                  if (this.props.reactionsArticles.length > 0) {
                    for (const reactionIndex in this.props.reactionsArticles) {
                      const reactionData = this.props.reactionsArticles[reactionIndex];
                      if (parseInt(reactionData.articleId, 10) === parseInt(articleData.id, 10)) {
                        totalReaction = parseInt(reactionData.totalReactions, 10);
                      }
                    }
                  }
                } else {

                  isBlocBouchon = true;
                  blocType = articleData;
                }

                // Main Image
                let Img = null
                if (articleData.hasOwnProperty("main_block") && articleData["main_block"].hasOwnProperty("content")) {
                  const imgName = articleData["main_block"]["content"];
                  Img = this.getFullImgUrl(imgName, 'xxlarge');
                }

                // Thematic
                let thematicName = '';
                let thematicSlug = '';
                if (this.props.availableThematics.length > 0) {
                  for (const thematicIndex in this.props.availableThematics) {
                    const currentThematic = this.props.availableThematics[thematicIndex];
                    if (currentThematic.slug === articleData.thematic) {
                      thematicName = currentThematic.name;
                      thematicSlug = currentThematic.slug;
                      break;
                    }
                  }
                }

                let position = '';
                if (articleRowData.length === 2) {
                  position = (blocIndex === 0) ? 'left' : 'right';
                }

                if (isBlocBouchon) {
                  let blocConfig = null;
                  if (config.blocBouchonConfig) {
                    if (config.blocBouchonConfig.hasOwnProperty(blocType)) {
                      blocConfig = config.blocBouchonConfig[blocType];

                    }
                  }

                  return ((blocConfig !== null)?
                    <FillingBloc key={blocIndex}  
                                            blocType={blocType}
                                            position= {position}
                                            background={blocConfig.background}
                                            title= {blocConfig.title}
                                            titleColor={blocConfig.titleColor}
                                            link={blocConfig.link}
                                            blocClicked = {this.props.onArticleClicked}
                                            />
                    :
                    []
                  );
                } else {

                  return (
                    <ArticleBloc key={blocIndex} 
                                            index={rowIndex+1} 
                                            position = {position}
                                            type={articleType} 
                                            title={articleData.title} 
                                            slug= {articleData.slug}
                                            articleId= {articleData.id} 
                                            thematic={thematicName}
                                            thematicUrl= {thematicSlug}  
                                            picture={Img} 
                                            likes={totalReaction} 
                                            articleClicked = {this.props.onArticleClicked}
                                            thematicClicked = {this.props.onThematicClicked}
                                            />
                  )
                }

              });

            });
          }
        }
      }
    }

    return (
      <Aux>
        { this.props.isGridDisplay===true?mainArticleOutput: []}
        { this.props.isGridDisplay===true? 
          <div className="grid">{listOutput}</div>: (listOutput)
        }
      </Aux>
    )
  }

}

const mapStateToProps = state => {
  return {
    user: state.user,
    uid: state.auth.uid,
    isUserSignedIn: state.auth.isUserSignedIn,
    availableEditions: state.editions,
    reactionsArticles: state.article.totalReactionsByArticles,
    articleContent: state.article.currentArticle,
    availableThematics: state.thematics.thematics,
    articlesByThematic: state.thematics.thematicArticleList,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    onArticleClicked: (articleId) => dispatch(articleActions.getArticleContent(articleId)),
    onFakeArticleClicked: (articleId) => dispatch(articleActions.getFakeArticleContent(articleId)),
    onThematicClicked: (thematicName) => dispatch(thematicActions.getArticlesByThematic(thematicName)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticlesListRenderer);


// WEBPACK FOOTER //
// ./src/components/ArticlesList/ArticlesListRenderer.js